import React from 'react'

const Cart = () => {
    return (
        <div>
            This is Cart page
        </div>
    )
}

export default Cart
